module.exports = __webpack_public_path__ + "static/media/debt.d7a70f32.png";